const $ = jQuery
export default function SmoothScroll() {
	const MAIN_HEADER_HEIGHT = document.getElementById('main_header')
	document.querySelectorAll('a[href^="#"]').forEach(anchor => {
		anchor.addEventListener('click', function (e) {
			e.preventDefault();

			if(this.getAttribute('href') === '#') {
				return;
			}

			var element = document.querySelector(this.getAttribute('href'));

			if(!element){
				return;
			}
			var adminBar = 0;
			if($('body').hasClass('admin-bar')){
				adminBar = 32;
			}
			var headerOffset = ((MAIN_HEADER_HEIGHT.getBoundingClientRect().height - 16) + adminBar);
			var elementPosition = element.getBoundingClientRect().top;
			var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

			window.scrollTo({
				top: offsetPosition,
				behavior: "smooth"
			});
		});
	});
}